import { Component } from '@angular/core';

import {
	NavController,
	LoadingController,
	IonicPage,
	NavParams,
	ToastController
} from 'ionic-angular';


import { AuthProvider } from '../../providers/auth/auth';
import { HousingUnitProvider } from '../../providers/housing-unit/housing-unit';

import { HousingUnit, Condominium } from '../../models/models';
import { CondominiumProvider } from '../../providers/condominium/condominium';

@IonicPage()
@Component({
	selector: 'page-housing-unit-create',
	templateUrl: 'housing-unit-create.html',
})
export class HousingUnitCreatePage {
	public isCondominiumLoading: boolean = true;
	public condominium: Condominium;
	public housingUnit: HousingUnit = {
		id: null,

		condominium: null,
		condominium_id: null,
		label: '',
		internal: '',
		stair: '',
		floor: '',

		messages: [],
		owners: [],
		residents: [],
		users: [],

		cadaster_city_code: null,
		cadastal_type: null,
		cadastal_administrative_section: null,
		cadastal_census_section: null,
		cadastal_urban_section: null,
		cadastal_paper: null,
		cadastal_particle: null,
		cadastal_subaltern: null,
		cadastal_zone: null,
		cadastal_microzone: null,
		cadastal_category: null,
		cadastal_class: null,
		cadastal_rooms: null,
		cadastal_revenue: null
	};

	public loading: any;

	constructor(
		public condominiums: CondominiumProvider,
		public navCtrl: NavController,
		public navParams: NavParams,
		public housingUnits: HousingUnitProvider,
		public loadingCtrl: LoadingController,
		public auth: AuthProvider,
		public toastCtrl: ToastController
	) {
		this.condominium = navParams.get('condominium');
		this.housingUnit.condominium = this.condominium;
		this.housingUnit.condominium_id = this.condominium.id;
	}

	public undo() {
		this.navCtrl.pop();
	}

	public save() {
		this.loading = this.loadingCtrl.create({
			content: 'Salvataggio in corso...',
			dismissOnPageChange: false
		});
		this.loading.present();
		this.housingUnits.store(this.housingUnit).then(
			(housingUnit: HousingUnit) => {
				this.loading.dismiss();
				let toast = this.toastCtrl.create({
					message: 'Unità abitativa "' + this.housingUnit.label + " - " + this.housingUnit.internal + '" salvata',
					position: 'middle',
					duration: 3000,
					cssClass: "light"
				});
				toast.present();
				this.navCtrl.pop();
			}).catch((error: any) => {
				this.loading.dismiss();
				let toast = this.toastCtrl.create({
					message: 'Errore creando l\'unità abitativa',
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				});
				toast.present();
				this.navCtrl.pop();
			}
			);
	}
	ionViewWillEnter() {
		let self = this;

		this.isCondominiumLoading = true;
		this.condominiums.getById(this.housingUnit.condominium_id, ['address']).then(
			(condominium: Condominium) => {
				self.housingUnit.condominium = condominium;
				self.isCondominiumLoading = false;
			}).catch((error: any) => {
				self.isCondominiumLoading = false;
				console.error("Errore recuperando il condominio dell\'unità immobliare:", error);
				let toast = this.toastCtrl.create({
					message: 'Errore recuperando il condominio dell\'unità immobliare',
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				}
				);
				toast.present();
			});
	}
}



// WEBPACK FOOTER //
// ./src/pages/housing-unit-create/housing-unit-create.ts